import {http} from '../core/services/http'
import {IPlannedPayment} from '../core/interfaces'
import {Pagination} from '../core/services/utils'

type PlannedPaymentParams = {
    page?: number
    size?: number
    sortBy?: string
    sortDirection?: string
    userName?: string
    kidName?: string
    showPaid?: boolean
    filterOverdue?: boolean
    filterNext?: boolean
}

export const getAllPlannedPayments = (params?: PlannedPaymentParams) =>
    http.get<Pagination<IPlannedPayment>>('/api/dashboard/planned-payments', {params})
